import React, { Component } from "react";
import PageTitle from "../../Theme/PageTitle/index.js";
import { Button, Modal, Table, Col, Row } from "antd";
import { InfoCard } from "../../../Components/Theme/Cards/index.js";
import { Link } from 'react-router-dom';
import { StrokeIcon } from "../../Theme/Icon/index.js";
import * as WrappedFindResourceForm from '../../Schedule/FindResourceForm.js';
import moment from 'moment'
import * as resourceActions from '../../../redux/actions/resourceActions.js';
import PropTypes from 'prop-types';
import AuthLogic from '../../../AuthLogic/index.js';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';

class SelectDayTypeResourceInfoCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      widescreen: false,
      resource: {
        id: '',
        name: ''
      },
      findResourceModal: false,
      areSearchFieldsValid: true,
      findResourceFields: {
        name: '',
        sso: '',
        withDisabled: false,
      },
      resources: '',
      resourceTable: {
        columns: [
          {
            title: 'Resource name',
            field: 'name',
            key: 'id',
            render: rowData => <a style={{ color: rowData.isDisabled ? 'red' : '' }} >{rowData.name}</a>

          },
          {
            title: 'Cost Center Name',
            dataIndex: 'dName',
            render: text => <a>{text}</a>
          },
        ],
        data: ''
      },
    };
  }

  componentDidMount = async () => {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }

  resize = () => {
    if (window.innerWidth >= 600) {
      this.setState({
        widescreen: true
      });
    } else {
      this.setState({
        widescreen: false
      });
    }
  }

  showModal = () => {
    this.setState({
      findResourceModal: true,
    });
  }

  handleModalCancel = (e) => {
    this.setState({
      findResourceModal: false,
    });
  }

  handleSearchFieldChange = (e) => {
    const findResourceFields = this.state.findResourceFields;
    if (e.target.id == "withDisabled") {
      findResourceFields[e.target.id] = e.target.checked;
    } else {
      findResourceFields[e.target.id] = e.target.value;
    }

    this.setState({
      findResourceFields: findResourceFields
    });
  }

  handleSearch = async (e) => {

    let { name, sso, withDisabled } = this.state.findResourceFields;
    const ssoRegex = /\d+/;
    const nameRegex = /\w+/;
    name = `%${name}%`;
    let testName = name.substring(1, name.length - 1);
    if ((sso && ssoRegex.test(sso)) || (testName && nameRegex.test(testName))) {
      await this.props.actions.fetchFindResource(name, sso, withDisabled).catch(error => {
        alert("Loading resources failed\n" + JSON.stringify(error));
      });
      this.setState({
        areSearchFieldsValid: true,
        resources: this.props.resources.resources
      }, () => {
        this.generateResourceTable();
      });
    } else {
      this.setState({ areSearchFieldsValid: false });
    }
  }

  handleSelectResource = async (record) => {
    const findResourceFields = {
      name: '',
      sso: '',
      withDisabled: false
    };
    await this.props.actions.updateSelectedDayTypeResource(record.id, record.name);
    if (this.props.updatePageCallback) { //optional callback to update the page with new information
      await this.props.updatePageCallback();
    }
    this.setState({
      resource: this.props.selectedDayTypeResource, // needs to reference redux
      findResourceModal: false,
      findResourceFields
    });
  }

  generateResourceTable = () => {
    const data = [];
    const { resources } = this.state;
    const resourceTable = this.state.resourceTable;
    for (let resource of resources) {
      const row = {
        key: resource.rowId,
        id: resource.id,
        name: resource.name,
        dName: resource.dName,
        isDisabled: resource.isDisabled
      };
      data.push(row);
    }
    resourceTable.data = data;
    this.setState({
      resourceTable
    });
  }

  render() {
    return (
      <React.Fragment>
        <Col lg={8} md={24} xs={18}>
          <Link to="#" onClick={this.showModal}>
            <InfoCard icon={<StrokeIcon icon={'search'} />}
              value={'Change Resource'} /></Link>
        </Col>
        <Modal
          zIndex={2000}
          title="Find Resource"
          open={this.state.findResourceModal}
          onCancel={this.handleModalCancel} // the x in top right corner
          footer={(_, { }) => (
            <>
            <Button color="danger" variant="solid" key="back" onClick={this.handleModalCancel}>Cancel</Button>
            <Button color="primary" variant="solid" key="submit" type="submit" onClick={this.handleSearch}>
              Search
            </Button></>)}
        >

          <WrappedFindResourceForm.default
            findResourceFields={this.state.findResourceFields}
            handleSearchFieldChange={this.handleSearchFieldChange}
            isValid={this.state.areSearchFieldsValid}
            handleSearch={this.handleSearch}
          />
          {this.state.resourceTable.data &&
            (
              <div>
                <Table
                  columns={this.state.resourceTable.columns}
                  dataSource={this.state.resourceTable.data}
                  size="small"
                  onRow={record => ({
                    onClick: (e) => this.handleSelectResource(record)
                  })}

                />
              </div>
            )
          }
        </Modal>
      </React.Fragment>
    )
  }
}

SelectDayTypeResourceInfoCard.propTypes = {
  user: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  resources: PropTypes.object,
  selectedDayTypeResource: PropTypes.object,
}

function mapStateToProps(state) {
  return {
    user: state.user,
    resources: state.resources,
    selectedDayTypeResource: state.selectedDayTypeResource,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      fetchFindResource: bindActionCreators(
        resourceActions.fetchFindResource,
        dispatch
      ),
      updateSelectedDayTypeResource: bindActionCreators(
        resourceActions.updateSelectedDayTypeResource,
        dispatch
      ),
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectDayTypeResourceInfoCard);
